import { InputBaseVariantType } from '../../../designSystem/reloaded/commons/components/inputBase/variants';
export var InputCurrencyConverterVariantType;
(function (InputCurrencyConverterVariantType) {
    InputCurrencyConverterVariantType["REGULAR"] = "REGULAR";
})(InputCurrencyConverterVariantType || (InputCurrencyConverterVariantType = {}));
export const currencyConverterVariantToBaseVariantMap = {
    [InputCurrencyConverterVariantType.REGULAR]: InputBaseVariantType.CURRENCY_CONVERTER_REGULAR,
};
//# sourceMappingURL=inputCurrencyConverterVariantType.js.map